export default "__VITE_ASSET__O3gYC5QJ__"